<template>
    <div>
        <div class="nav">
            <router-link to="/" class="logo-wrap">
                <img :src="$root.siteInfo.websiteLogo || 'error'" class="logo" onerror="this.src='/images/logo.png'">
            </router-link>
            <ul>
                <button></button>
                <div class="li-wrap">
                    <li>
                        <div class="main-link"><router-link to="/home" exact="">{{ lang("nav_index") }}</router-link></div>
                    </li>
                    <li>
                        <div class="main-link"><router-link to="/about">{{ lang("nav_about") }}</router-link></div>
                        <!-- <transition name="fade">
                            <div class="dropDown">
                                <div><router-link to="/about/1">{{ lang("nav_about_distribution") }}</router-link></div>
                                <div><router-link to="/about/2">{{ lang("nav_about_idea") }}</router-link></div>
                                <div><router-link to="/about/3">{{ lang("nav_about_honor") }}</router-link></div>
                                <div><router-link to="/about/4">{{ lang("nav_about_history") }}</router-link></div>
                            </div>
                        </transition> -->
                    </li>
                    <li>
                        <div class="main-link"><router-link :to="'/subsidiary/characteristic/' + ($root.companyList.length > 0 ? $root.companyList.filter(v => v.companyName != '永太和集团' && v.companyName != 'yth')[0].id : $root.groupId)" :class="{ 'active': isLink1($route.path) }">{{ lang("nav_company") }}</router-link></div>
                        <transition name="fade">
                            <div class="dropDown">
                                <div v-for="item in $root.companyList.filter(v => v.companyName != '永太和集团' && v.companyName != 'yth')">
                                    <router-link :to="'/subsidiary/characteristic/' + item.id" :class="{ 'active': isLink($route.path, item.id) }">{{ item.companyName }}</router-link>
                                </div>
                            </div>
                        </transition>
                    </li>
                    <li>
                        <div class="main-link"><router-link to="/products">{{ lang("nav_products") }}</router-link></div>
                        <transition name="fade">
                            <div class="dropDown">
                                <div><router-link to="/products/server">{{ lang("nav_pro_printing") }}</router-link></div>
                                <div><router-link to="/products/display">{{ lang("nav_pro_display") }}</router-link></div>
                                <div><router-link to="/products/equipment">{{ lang("nav_pro_equipment") }}</router-link></div>
                            </div>
                        </transition>
                    </li>
                    <li>
                        <div class="main-link"><router-link to="/tech/advantage">{{ lang("nav_tech") }}</router-link></div>
                        <transition name="fade">
                            <div class="dropDown">
                                <div><router-link :to="'/tech/advantage/laboratory'">{{ lang("nav_tech_laboratory") }}</router-link></div>
                                <div v-for="item in typeKey">
                                    <router-link :to="'/tech/advantage/' + item.value">{{ item.label }}</router-link>
                                </div>
                            </div>
                        </transition>
                    </li>
                    <li>
                        <div class="main-link"><a href="javascript:void()">{{ lang("nav_print") }}</a></div>
                        <transition name="fade">
                            <div class="dropDown">
                                <div><a href="https://www.xjl698.com/" target="_blank">{{ lang("nav_digital_print") }}</a></div>
                                <div><router-link to="/building">{{ lang("nav_Traditional_print") }}</router-link></div>
                            </div>
                        </transition>
                    </li>
                    <li>
                        <div class="main-link"><router-link to="/news">{{ lang("nav_news") }}</router-link></div>
                    </li>
                    <li>
                        <div class="main-link"><router-link to="/hr">{{ lang("nav_human") }}</router-link></div>
                        <transition name="fade">
                            <div class="dropDown">
                                <div><router-link to="/hr/recruit">{{ lang("nav_index_recruit") }}</router-link></div>
                            </div>
                        </transition>
                    </li>
                    <li v-if="token">
                        <div class="main-link"><router-link to="/video">{{ lang("nav_video") }}</router-link></div>
                    </li>
                </div>
            </ul>
            <!-- <div class="langs">
                <button @click="showLogin" class="lang loginBtn">
                    <span v-if="!token">登录</span>
                    <span v-else>退出登录</span>
                </button>
            </div> -->
            <div class="langs">
                <div class="language">
                    <button :class="['lang', { active: $root.langMode == 0 }]" @click="$root.langMode = 0">中</button>
                    <button :class="['lang', { active: $root.langMode == 1 }]" @click="$root.langMode = 1">EN</button>
                </div>
            </div>

        </div>
        <transition name="fade">
            <div class="loginBox" v-if="loginBox">
                <div class="box">
                    <div class="loginBg"></div>
                    <div class="login">
                        <h3 @click.stop="">
                            <div class="title">
                                <div>登录</div>
                                <div class="subtitle">Sign In</div>
                            </div>

                            <span class="triangle"></span>
                        </h3>
                        <div class="form" @click.stop="">
                            <dl>
                                <dt>
                                    <strong>*</strong>{{ lang("login_name") }} ：
                                </dt>
                                <dd>
                                    <input autocomplete="name" v-model="login.username" @input="apiStatus = 'ready'">
                                </dd>
                            </dl>
                            <dl>
                                <dt>
                                    <strong>*</strong>{{ lang("login_pwd") }} ：
                                </dt>
                                <dd>
                                    <input v-model="login.password" @input="apiStatus = 'ready'" type="password">
                                </dd>
                            </dl>
                        </div>
                        <button class="submit" @click="submitLogin()" binding="login" :disabled="login.username == '' || login.password == '' || apiStatus != 'ready'">{{ ({ ready: '登录', working: '正在登录', verified: '验证通过', success: '登录成功', error: errorMSG || '登录失败' }[apiStatus]) }}</button>
                        <button class="close" @click.stop="loginBox = false"></button>
                    </div>
                </div>
            </div>
        </transition>
        <div class="cover" v-if="loginBox"></div>
    </div>
</template>
<style lang="less" scoped>
@activeColor: #E60012;

.nav {
    height: 80px;
    background-color: white;
    display: flex;
    justify-content: center;
    // align-items: center;
    font-size: 16px;
    position: relative;
    z-index: 100;
    left: 0;
    top: 0;
    right: 0;
    box-shadow: 0 0 6px rgba(0, 0, 0, .1);
    padding: 0 30px;

    .bd {
        width: 100%;
        height: 214px;
        background: rgba(255, 255, 255, 0.9);
        position: fixed;
        top: 80px;
        left: 0;
        z-index: 99;
    }

    .logo {
        max-height: 50px;
        max-width: 300px;
    }

    ul {
        list-style: none;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        margin: 0 auto 0 50px;

        button {
            display: none;
        }

        .li-wrap {
            display: flex;
            height: 100%;
        }

        li {
            padding: 0;
            margin: 0;
            position: relative;
            height: 100%;
            display: flex;
            align-items: center;
            white-space: nowrap;

            .main-link {
                height: 100%;
                display: flex;
                align-items: center;

                a {
                    padding: 0 30px;
                    display: flex;
                    height: 100%;
                    align-items: center;
                }
            }

            .dropDown {
                font-size: 15px;
                // width: 202px;
                position: absolute;
                top: 80px;
                left: 0px;
                background-color: rgba(255, 255, 255, 0.9);
                line-height: 50px;
                white-space: nowrap;
                border-radius: 0 0 3px 3px;
                box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .2);
                text-align: left;
                overflow: hidden;
                transform-origin: center top;
                transform: scale(1, 0);
                transition: all 0.2s;

                div {
                    // padding: 0 20px;
                    min-width: 168px;
                    cursor: pointer;

                    &:hover {
                        color: #ffffff;
                        background-color: @activeColor;
                    }

                    a {
                        display: inline-block;
                        padding: 0 20px;
                        height: 50px;
                        width: 100%;

                        &.router-link-active,
                        &:hover,
                        &.active {
                            color: #ffffff;
                            background-color: @activeColor;
                        }

                    }
                }
            }

            &:hover {
                .dropDown {
                    transform: scale(1, 1);
                }
            }

            a {

                &.router-link-active,
                &:hover,
                &.active {
                    color: @activeColor;
                    text-shadow: 0 0 1px @activeColor;
                }

            }
        }
    }

    .logo-wrap {
        display: flex;
        align-items: center;
        margin-right: 50px;
    }

    .langs {
        display: flex;
        height: 100%;
        align-items: center;
        line-height: 24px;
        // margin-right: 10px;

        .lang {
            display: inline-block;
            border: none;
            background-color: transparent;
            line-height: inherit;
            width: 38px;
            height: 32px;
            color: #353535;

            &.loginBtn {
                background: transparent url(../assets/images/nav/personal.png) left no-repeat;
                width: 108px;
                text-align: left;
                padding-left: 22px;
                // width: 133px;
                white-space: nowrap;
                padding-left: 23px;
                // padding-right: 30px;
                text-align: left;
            }

            &.active {
                color: #FFFFFF;
                background: rgba(255, 0, 0, 1);
                border-radius: 16px;
            }
        }

        .language {
            width: 80px;
            height: 32px;
            border: 2px solid #FF0000;
            display: flex;
            align-items: center;
            border-radius: 16px;
            box-sizing: border-box;

            .lang {
                color: #FF0000;

                &.active {
                    color: #FFFFFF;
                }
            }
        }
    }
}

.loginBox {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 102;
    // will-change: opacity;

    .box {
        position: relative;
        width: 440px;
        height: 344px;
    }

    .loginBg {
        position: absolute;
        top: 23px;
        width: 440px;
        height: 299px;
        z-index: 101;
        background-color: @activeColor;
    }

    .login {
        position: absolute;
        left: 20px;
        width: 400px;
        height: 344px;
        background-color: white;
        padding: 26px 20px;
        border: none;
        overflow: hidden;
        z-index: 102;

        h3 {
            text-align: left;
            margin: 0 0 20px 0;
            font-size: 20px;
            font-weight: 400;
            background: url(../assets/images/nav/logo_bg.png) no-repeat left center;
            padding-left: 9px;

            .subtitle {
                font-size: 16px;
                font-family: Roboto;
                font-weight: 900;
                color: #888888;
            }

            .title {
                width: 151px;
                display: inline-block;
            }

            .triangle {
                display: inline-block;
                border: 5px solid transparent;
                border-bottom: 5px solid @activeColor;
                border-right: 5px solid @activeColor;

            }
        }

        .form {
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 400;

            strong {
                color: #e60012;
                margin-right: 2px;
            }

            dl {
                margin: 0 0 21px 0;

                dt {
                    text-align: left;
                    color: #666;
                    line-height: 24px;
                }

                dd {
                    margin: 0;

                    input,
                    textarea {
                        margin: 0;
                        width: 100%;
                        border: none;
                        border-bottom: 1px solid #ccc;
                        padding: 6px;
                        resize: none;
                        line-height: 24px;
                        background: transparent;
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                    }

                    textarea {
                        height: 178px;
                    }
                }
            }
        }

        .submit {
            border: none;
            background-color: #e60012;
            color: white;
            height: 40px;
            width: 100%;
            transition: all .2s;
            margin-top: 26px;

            &:disabled {
                opacity: 0.3;
            }

            &.error,
            &.success,
            &.working {
                color: white;
                display: flex;
                justify-content: center;

                span {
                    flex: none;
                    order: 1;
                }

                &:after {
                    background-color: transparent;
                    border-left: none;
                }

                &:before {
                    position: relative;
                    order: 2;
                    margin-left: 5px;
                }
            }

            &.working {
                &:before {
                    border-top-color: white;
                }

                &:after {
                    display: none;
                }
            }

            &:hover {
                background-color: #e60012;
                opacity: .8;
            }
        }

        .close {
            border: none;
            width: 17px;
            height: 17px;
            position: absolute;
            right: 22px;
            top: 22px;
            background: transparent url(../assets/images/index/close.png) center/auto no-repeat;
        }

        &.expand {
            width: 400px;
            height: 515px;
            background-color: white;
            background-image: none;
            border-radius: 5px;
            top: calc(50% - 200px);
            z-index: 20;
            cursor: default;
            padding: 30px;
            transition: all .4s, z-index 0s;
        }
    }
}

.cover {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .7);
    z-index: 100;
}

@media screen and (max-width: 1482px) {
    .nav {
        height: 60px;
        justify-content: space-between;
        padding: 0 60px 0 20px;

        .logo {
            max-height: 30px;
            max-width: 200px;
        }

        ul {
            position: absolute;
            right: 10px;
            top: 10px;
            flex-direction: column;
            margin: 0;
            height: auto;
            overflow: visible;
            padding: 0;
            align-items: stretch;

            .li-wrap {
                flex-direction: column;
            }

            &:hover {
                .li-wrap {
                    box-shadow: 0 0 5px rgba(0, 0, 0, .2);
                }

                li {
                    display: block;
                }
            }

            button {
                display: block;
                width: 40px;
                height: 40px;
                margin-bottom: 20px;
                align-self: flex-end;
                border: none;
                background: transparent url(../assets/images/nav/menu.svg) center/26px no-repeat;
            }

            li {
                background-color: rgba(255, 255, 255, .9);
                text-align: center;
                margin: 0;
                padding: 0;
                position: relative;
                display: none;
                min-width: auto;

                &:not(:last-child) {
                    border-bottom: 1px solid #ddd;
                }

                .main-link {
                    display: block;
                    width: 100%;
                    height: 100%;
                    line-height: 20px;
                    font-size: 14px;
                    color: #353535;
                    text-align: center;
                    padding: 0;
                    position: relative;
                    cursor: pointer;

                    a {
                        padding: 0 30px;
                        display: block;
                        height: 50px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }

                .dropDown {
                    right: calc(100% + 3px);
                    left: auto;
                    top: 0;
                    box-shadow: 0 0 5px rgba(0, 0, 0, .2);

                    &>div {
                        display: flex;
                    }

                    a {
                        padding: 0 30px;
                        height: 50px !important;
                        display: flex !important;
                        align-items: center;
                        line-height: normal;
                    }
                }
            }
        }
    }

}
</style>
<script>
export default {
    data() {
        return {
            loginBox: false,
            login: {
                username: '',
                password: '',
                type: 'login',
                scope: 'server',
                grant_type: 'password'
            },
            apiStatus: "ready",
            errorMSG: '',
            typeKey: [],

        }
    },
    mounted() {
        this.getTypeKey();
    },
    methods: {
        isLink(s, id) {
            var reg = new RegExp("^/subsidiary.+/" + id)
            return reg.test(s)
        },
        isLink1(s) {
            var reg = new RegExp("^/subsidiary.+")
            return reg.test(s)
        },
        showLogin() {
            if (!this.token) {
                this.loginBox = true
            } else {
                sessionStorage.removeItem("token");
                this.token = sessionStorage.getItem("token");
                this.apiStatus = "ready";
                if (this.$route.path == "/video") {
                    this.$router.push({
                        path: "/"
                    })
                }
            }

        },

        submitLogin() {
            var that = this;
            that.apiStatus = "working";
            ajax.call(this, {
                url: "/oauth/token",
                type: "post",
                headers: {
                    Authorization: 'Basic d2Vic2l0ZUJsb2M6YmxvYzEyMw=='
                },
                data: that.login,
                s(res) {
                    switch (res.code) {
                        case "1":
                            that.errorMSG = res.msg;
                            that.apiStatus = "error";
                            break;
                        case undefined:
                            that.apiStatus = "success";
                            that.token = "Bearer " + res.access_token;
                            sessionStorage.setItem("token", "Bearer " + res.access_token);
                            that.loginBox = false;
                            break;
                    }
                }
            });
        },
        getTypeKey() {
            var that = this;
            ajax.call(this, {
                url: "/admin/category/typeKey",
                data: {
                    // SERVER_SORT服务,PRODUCT_SORT产品,DEVICE_SORT设备,TECHNOLOGY_SORT工艺,POSITION_SORT职位,VIDEO_SORT视频,OTHER_SORT其他
                    typeKey: "TECHNOLOGY_SORT"
                },
                s(res) {
                    that.typeKey = res.data;
                }
            });
        },

    },
    watch: {
        "$root.language"() {
            this.getTypeKey();
            this.$root.getCompanyList(-1);
        },

    }
}
</script>